exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog form {\n\tmargin-bottom: 0 !important;\n}\n", ""]);

// exports
